<template>
  <div
    @click="onClick"
    :class="
      `filter-option-btn ${isDisable ? 'disable' : ''} ${
        selected ? 'selected' : ''
      }`
    "
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['isDisable', 'selected'],
  methods: {
    onClick() {
      if (this.isDisable) return;
      this.$emit('onClick');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.filter-option-btn {
  background: #ffffff;
  border: 1px solid #f3f5fa;
  color: #828c9f;
  box-sizing: border-box;
  width: fit-content;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 16px;
  cursor: pointer;
  font-family: Inter-Regular;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: $primary-color;
    color: #fff;
    border: 1px solid $primary-color;
  }
  &.disable {
    background-color: #f3f5fa;
    cursor: not-allowed;
    &:hover {
      background-color: #f3f5fa;
      color: #828c9f;
      border: 1px solid #f3f5fa;
    }
  }
  &.selected {
    background-color: $primary-color;
    color: #fff;
  }
}
</style>
